
export class OrderCancel {
    constructor({modalId, modalTriggerId, modalSubmitId, orderAlertId}) {
        this.modal = document.getElementById(modalId);
        this.modalTrigger = document.getElementById(modalTriggerId);
        this.init(modalSubmitId, orderAlertId);
    }

    async initBootstrapModal() {
        if (this.modal) {
            let {default: Modal} = await import('bootstrap/js/dist/modal');
            this.bootstrapModal = new Modal(this.modal, {});
        }
    }

    async init(modalSubmitId, orderAlertId) {
        await this.initBootstrapModal();
        this.modalSubmit = document.getElementById(modalSubmitId);
        this.orderAlert = document.getElementById(orderAlertId);

        this.body = document.querySelector('body');
        this.html = document.querySelector('html');
        this.listen();
    }

    listen() {
        const thisClass = this;

        this.modalTrigger?.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            thisClass.bootstrapModal.show();
        });

        this.modalSubmit?.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const href = document.querySelector('input[name="cancel-order-reason"]:checked').value;

            thisClass.getData(href)
                .then((data) => {
                    thisClass.redraw(data);
                });
        });

        const radioButtons = document.querySelectorAll('input[name="cancel-order-reason"]');
        radioButtons?.forEach((radioButton) => {
            radioButton.addEventListener('click', function (e) {
                if (thisClass.modalSubmit) {
                    thisClass.modalSubmit.removeAttribute('disabled');
                }
            });
        });
    }

    getData(url) {
        return fetch(url)
            .then(data => {
                return data.json();
            }).then().catch(error => {
            });
    }

    redraw(data) {
        this.orderAlert.classList.remove('d-none');

        if (data.message) {
            this.orderAlert.classList.add('alert-success');
            this.orderAlert.innerHTML = data.message;
        } else {
            this.orderAlert.classList.add('alert-danger');
            this.orderAlert.innerHTML = data.error;
        }

        this.bootstrapModal.hide();

        location.reload();
    }

}
